import React, { useRef } from 'react';

export default function PopupFollow(props: any) {
  const wrapRef = useRef(null);

  if (!React.isValidElement(props.children) || !React.Children.only(props.children)) return props.children;

  const { children: elementHasPopup, containerStyle, containerClassName, ..._props } = props;

  const { getPopupContainer } = elementHasPopup.props;

  if (typeof getPopupContainer === 'function') return React.cloneElement(elementHasPopup, _props);

  function innerGetPopupContainer() {
    return wrapRef.current;
  }

  return (
    <div className={containerClassName} style={containerStyle} ref={wrapRef}>
      {React.cloneElement(elementHasPopup, {
        ..._props,
        getPopupContainer: innerGetPopupContainer,
      })}
    </div>
  );
}
